<template>
  <div>
    <div>
      <div class="vx-col w-full">
        <vx-card title="Try & Buy List">
          <template slot="actions">
            <vs-button class="mt-0 w-full" color="success"  icon-pack="feather" icon="icon-plus" @click="addNewTrail">Add New</vs-button>
          </template>
          <template >
            <div class="vx-col md:w-1/1 w-full mb-base">
              <div class="vx-row  ">
                <div class="vx-col sm:w-1/6">
                  <vx-input-group class="mb-base">
                    <datepicker class="w-full" :format="customFormatter(fromDate)" placeholder="Select From Date" v-model="fromDate"></datepicker>
                    <template slot="append">
                    <div class="append-text btn-addon">
                      <vs-button color="rgb(118, 118, 118)" type="border" @click="clearDateFr" icon-pack="feather" icon="icon-x"></vs-button>
                    </div>
                  </template>
                  </vx-input-group>
                </div>
                <div class="vx-col sm:w-1/6">
                  <vx-input-group class="mb-base">
                    <datepicker class="w-full" :format="customFormatter(toDate)" placeholder="Select To Date" v-model="toDate"></datepicker>
                    <template slot="append">
                      <div class="append-text btn-addon">
                        <vs-button color="rgb(98, 98, 98)" type="border" @click="clearDateTo" icon-pack="feather" icon="icon-x"></vs-button>
                      </div>
                    </template>
                  </vx-input-group>

                </div>
                <div class="vx-col sm:w-1/6">
                  <v-select v-model="queryParam.day_count" class="mt-0 w-full" :options="rays" placeholder="Remaining Days" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                </div>
                <div class="vx-col sm:w-1/6 ">
                  <v-select  v-model="queryParam.status" class="mt-0 w-full" :options="statusList" placeholder="Select Status" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                </div>
                <div class="vx-col sm:w-1/6 ">
                  <vs-input class="mt-0 mr-2 w-full" placeholder="Search by NID"   type="text" v-model="queryParam.customer_nid"/>
                </div>
                <div class="vx-col sm:w-1/6">
                  <vs-input class="mt-0 mr-2 w-full" placeholder="Search by Mobile No"  type="text" v-model="queryParam.customer_mobile"/>
                </div>
              </div>
            </div>
          </template>
            <div class="con-tab-ejemplo">
                <div class="">
                  <div class="vx-row">
                    <div class="vx-col w-full ">
                      <div id="data-list-list-view" class="data-list-container">
                        <vs-table
                          :sst="true"
                          @search="handleSearch"
                          @change-page="handleChangePage"
                          @sort="handleSort"
                          v-model="selected"
                          :total="totalItems"
                          pagination
                          :max-items="perPage"
                          :data="traillList">
                          <!--<template slot="header">
                            <h3>
                              Washing Machine Trail List
                            </h3>
                          </template>-->
                          <template slot="thead">
                            <vs-th sort-key="id">
                              Id
                            </vs-th>
                            <vs-th sort-key="name">
                              Name
                            </vs-th>
                            <vs-th sort-key="customer_mobile">
                              Customer Mobile
                            </vs-th>
                            <vs-th sort-key="customer_address">
                              Article
                            </vs-th>
                            <vs-th sort-key="day_count">
                              Remaining Days
                            </vs-th>
                            <vs-th sort-key="end_at">
                              End Date
                            </vs-th>
                            <vs-th sort-key="status">
                              Status
                            </vs-th>
                            <vs-th sort-key="id">
                              Action
                            </vs-th>
                          </template>

                          <template slot-scope="{data}">
                            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                              <vs-td :data="data[indextr].id">
                                {{data[indextr].id}}
                              </vs-td>
                              <vs-td :data="data[indextr].customer_name">
                                {{data[indextr].customer_name}}
                              </vs-td>
                              <vs-td :data="data[indextr].customer_mobile">
                                {{data[indextr].customer_mobile}}
                              </vs-td>
                              <vs-td :data="data[indextr].product_article">
                                {{data[indextr].product_article}}
                              </vs-td>
                              <vs-td :data="data[indextr].day_count">
                                {{data[indextr].day_count}}
                              </vs-td>
                              <vs-td :data="data[indextr].end_at">
                                <span v-if="data[indextr].end_at">{{dateFormateer(data[indextr].end_at)}}</span>
                              </vs-td>
                              <vs-td :data="data[indextr].status">
                                <vs-chip style="color:rgba(0,0,0,0.87); font-weight: bold" v-if="data[indextr].status" :color="getOrderStatusColor(data[indextr].status)" class="product-order-status">
                                  {{data[indextr].status}}
                                </vs-chip>
                              </vs-td>
                              <vs-td class="whitespace-no-wrap">
                                <vs-button color="primary" type="flat" :disabled="data[indextr].status!=='On Trial'"><feather-icon icon="EditIcon"  @click="updateTrail(data[indextr].id)"
                                              svgClasses="w-5 h-5 hover:text-primary stroke-current"
                                              class="clickable"/></vs-button>
                                <feather-icon v-if="data[indextr].status==='Sold' || data[indextr].status==='On Trial'" icon="ArrowDownIcon" @click="downloadAgreement(data[indextr].id)" svgClasses="w-5 h-5 hover:text-danger stroke-current"
                                              class="ml-2 clickable"/>
                                <!--<feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current"
                                              class="ml-2 clickable"/>-->
                                <!--<feather-icon icon="EyeIcon" @click="footFallDetal(data[indextr].id)"
                                              svgClasses="w-5 h-5 hover:text-success stroke-current"
                                              class="ml-2 clickable"/>-->
                              </vs-td>
                            </vs-tr>
                          </template>
                        </vs-table>

                        <!--<pre ref="pre"></pre>-->
                      </div>
                    </div>
                  </div>
                </div>
            </div>

        </vx-card>
      </div>
    </div>
  </div>
</template>
<script>
  import Datepicker from 'vuejs-datepicker'
  import moment from 'moment'
  import vSelect from 'vue-select'
  import gql from 'graphql-tag'

  export default {
    data () {
      return {
        currentSuffix:'',
        traillList: [],
        totalItems: 0,
        selectedPgae: 1,
        selected: [],
        activeLoading: false,
        colorx:'success',
        perPage: 0,
        queryParamLength: 3,
        fromDate:'',
        toDate:'',
        queryParam:{
          customer_nid: '',
          customer_mobile: '',
          day_count: '',
          first: 25,
          page: 1,
          status:'',
          created_at: {
            from:'',
            to:''
          },
          orderBy:[{ column: "updated_at", order:"DESC" }, { column: "id", order:"DESC" } ]
        },
        statusList:['Pending','On Trial','Sold','Return','Rejected'],
        dayList:['0',1,2,3,4,5,6,7,8,9,10,11,12,13,14,15]
      }
    },
    apollo: {
      me: {
        query: gql`
        query me($customer_mobile: String, $customer_nid: String, $day_count: Int, $created_at:DateRange, $status: String, $first: Int!, $page: Int, $orderBy: [OrderByClause!]){
            me{
            id
            suffix
            manager_name
            phone
            email
            address
            api_token
            trails(customer_mobile:$customer_mobile, customer_nid:$customer_nid, day_count: $day_count, created_at:$created_at, status:$status, first:$first, page:$page, orderBy: $orderBy){
            paginatorInfo{
                  count
                  currentPage
                  firstItem
                  hasMorePages
                  lastItem
                  lastPage
                  perPage
                  total
                }
              data{
                id
                product_article
                product_sl
                customer_nid
                customer_name
                customer_mobile
                customer_address
                agreed
                status
                day_count
                end_at
                remarks
                created_at
                updated_at
              }
            }
           }
         }
        `,
        variables () {
          this.queryParam.page = this.selectedPgae;
          if(this.fromDate !=='' && this.toDate !==''){
            let toDt = moment(this.toDate).add(1, 'days');
            this.queryParam.created_at = {
              from : moment(this.fromDate).format('yyyy-MM-DD'),
              to: moment(toDt).format('yyyy-MM-DD')
            }
            console.log("ppp",this.queryParam)
          }else {
            delete this.queryParam.created_at;
          }
          let val = Object.keys(this.queryParam)
            .filter((k) => this.queryParam[k] != '')
            .reduce((a, k) => ({ ...a, [k]: this.queryParam[k] }), {});
          if(Object.keys(val).length > this.queryParamLength){
            this.queryParam.page = 1;
            this.selectedPgae = 1;
            this.queryParamLength = Object.keys(val).length;
          }
          return val
        },
        update: (data) => data.me
      },
      rays:{
        query: gql`
          query rays{
            rays
          }
        `
      }
    },
    watch: {
      me (value) {
        this.$apollo.queries.me.refetch()
        this.currentSuffix = value.suffix;
        this.traillList = value.trails.data
        this.pagination = value.trails.paginatorInfo
        this.totalItems = this.pagination.total
        this.perPage = this.pagination.perPage
      },
      '$apollo.loading': function (loading) {
        if (loading === true) {
          this.$vs.loading({
            type: 'sound'
          })
        } else {
          this.$vs.loading.close()
        }
      },

    },
    methods: {
      dateFormateer(dateVal){
        return moment(dateVal).format('DD-MM-yyyy')
      },
      clearDateFr(){
        this.fromDate = ''
      },
      clearDateTo(){
        this.toDate = ''
      },
      clearSearch(){
        this.fromDate = '';
        this.toDate = '';
      },
      customFormatter(fromDate, toDate) {
        if(fromDate)
          return moment(fromDate).format('yyyy-MM-DD');
        else
          return moment(toDate).format('yyyy-MM-DD');
      },
      addNewTrail () {
        this.$router.push('/new_try_and_buy').catch(() => {})
      },
      updateTrail (id) {
        this.$router.push('/update_try_and_buy/' + id).catch(() => {
        })
      },
      handleSearch (searching) {
        let _print = `The user searched for: ${searching}\n`
        this.$refs.pre.appendChild(document.createTextNode(_print))
      },
      handleChangePage (page) {
        //let _print = `The user changed the page to: ${page}\n`
        this.selectedPgae = page
        //this.$refs.pre.appendChild(document.createTextNode(_print))
      },
      handleSort (key, active) {
        let _print = `the user ordered: ${key} ${active}\n`
        this.$refs.pre.appendChild(document.createTextNode(_print))
      },
      downloadAgreement(id){
        /*this.pdfFile =  "http://182.160.118.196:84/trial/"+this.currentSuffix+"/"+id+"";*/
        this.pdfFile =  "https://hire.butterflygroupbd.com/bml/trial/"+this.currentSuffix+"/"+id+"";
        return window.open(this.pdfFile);
      },
      getOrderStatusColor (status) {
        if (status === 'On Trial') return 'rgb(255,223,0)'
        if (status === 'Pending') return 'rgb(173,216,230)'
        if (status === 'Rejected') return 'rgb(255, 140, 0)'
        if (status === 'Sold') return 'rgb(144,238,144)'
        if (status === 'Return') return 'rgb(205,92,92)'
        return ''
      },

    },
    components: {
      Datepicker,
      'v-select': vSelect,
    }
  }
</script>
